import { useState } from 'react';
import { useOrderItemRefunds } from '../../utils/api.hook';
import { usePagination } from '../../shared/usePagination';
import { ProductRefundComponent } from './product-refund.component';
import { FilterValue } from 'antd/es/table/interface';

export function ProductRefundContainer() {
  const [filters, setFilters] = useState<Record<string, FilterValue | null>>(
    {}
  );
  const pagination = usePagination();
  const {
    data: { refunds, total, providerFilters, timeFilters } = {},
    isLoading,
  } = useOrderItemRefunds({
    ...filters,
    skip: pagination.skip,
    take: pagination.take,
  });

  return (
    <ProductRefundComponent
      isLoading={isLoading}
      providerFilters={providerFilters || []}
      refunds={refunds || []}
      setFilters={setFilters}
      timeFilters={timeFilters || []}
      pagination={{
        ...pagination,
        total,
      }}
    />
  );
}
